import { Button } from "@repo/ui/components/Base/Button";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@repo/ui/components/Base/Dialog";

export const MeetingRunModeDialog = ({
  open,
  setOpen,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  onCancel?: () => void;
  onConfirm?: (choice: "edit" | "run") => void;
}) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Run or Edit Meeting</DialogTitle>
        </DialogHeader>
        <DialogBody className="flex flex-col gap-y-4">
          <p>
            Do you want to run the meeting live, or edit the details of the
            previous run?
          </p>
          <p>
            When running a meeting live, timestamps are saved which are used to
            order the items chronologically rather than sequentially, and will
            also appear in the generated meeting minutes to help coordinate
            edits with a recording.
          </p>
          <p>
            <strong>Edit Previous Run:</strong> Don't update these timestamps.
            Instead, just make edits without affecting the recorded order of
            items and motions. In this case, new motions cannot be added (since
            doing so records the time at which they were added).
          </p>
          <p>
            <strong>Run Meeting Live:</strong> Continue running the meeting
            live. Use this option if the meeting was either not actually
            started, or if it was started, then paused for a recess, and is now
            coming back into procession.
          </p>
        </DialogBody>
        <DialogFooter className="flex flex-row gap-x-4">
          <Button
            variant="destructive"
            onClick={() => {
              setOpen(false);
              onCancel?.();
            }}
          >
            Cancel
          </Button>

          <div className="flex-grow" />

          <Button
            variant="secondary"
            onClick={() => {
              setOpen(false);
              onConfirm?.("edit");
            }}
          >
            Edit Previous Run
          </Button>
          <Button
            onClick={() => {
              setOpen(false);
              onConfirm?.("run");
            }}
          >
            Run Meeting Live
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
